module.exports = __webpack_public_path__ + "img/wentelteefjes.d01236f2.jpeg";